import api from "@/utils/http";

/**
 功能：
 time: 2026/1/6 18:09
 **/
export function getInvoiceConfig() {
    return api.get('/admin/invoice/getSetConfig')
}
/**
 功能：
 time: 2026/1/6 18:09
 **/
export function getInvoiceList(data) {
    return api.post('/partner/invoice/getList', data)
}

/**
 功能：
 time: 2026/3/9 17:29
 **/
export function getInvoiceStatic(data) {
    return api.post('/partner/invoice/getStaticData', data)
}
/**
 功能：
 time: 2025/12/25 16:02
 **/
export function saveInvoice(data) {
    return api.post('/admin/invoice/eSave', data)
}

/**
 功能：
 time: 2026/1/7 09:40
 **/
export function oSaveInvoice(data) {
    return api.post('/admin/invoice/oSave', data)
}

/**
 功能：
 time: 2026/1/7 09:50
 **/
export function getInvoiceDetail(inv_id) {
    return api.post('/partner/invoice/getDetail', {inv_id })
}

/**
 功能：
 time: 2026/1/7 10:04
 **/
export function deleteInvoice(inv_id) {
    return api.post('/admin/invoice/del', {inv_id})
}



